import { MouseEvent, ReactNode } from "react"
import { templateDetailRoute, useRouteContext } from "../../../features/route/RouteProvider"

type TemplateLinkProps = {
  to: string
  children: ReactNode
}

/**
 * Inline cross-template link. Keeps navigation SPA-side so the shared-element
 * card transition still runs when moving between /templates/:a and
 * /templates/:b. Passes from="templates" so the back-nav on the destination
 * lands on the grid rather than root.
 */
export function TemplateLink({ to, children }: TemplateLinkProps) {
  const [, setRoute] = useRouteContext()
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setRoute(templateDetailRoute(to, "templates"))
  }
  return (
    <a href={`/templates/${to}`} onClick={handleClick}>
      {children}
    </a>
  )
}
